// @flow
import React from 'react';
import { FooterLink } from 'components/atoms/footerLink';
import type {
  FooterLinkProps,
  FooterLinkType,
} from 'components/atoms/footerLink';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  links: Array<FooterLinkProps>,
  type?: FooterLinkType,
};

export const FooterMenu = (props: Props) => {
  const { links, type } = props;
  if (links.length === 0) {
    return null;
  }
  return (
    <ul className={'footer-menu'}>
      {links.map((link: FooterLinkProps, idx: number) => {
        return (
          <li key={idx.toString()}>
            <FooterLink
              title={link.title}
              link={link.link}
              prefix={link.prefix}
              type={type}
            />
          </li>
        );
      })}
    </ul>
  );
};
